export interface IRequest {
  requestType: string;
  url: string;
  body: string;
}

export class Request implements IRequest {
  constructor(
    public requestType: string,
    public url: string,
    public body: string
  ) {}
}
